import { render, staticRenderFns } from "./ErrorAdmin.vue?vue&type=template&id=7ad5b11e"
import script from "./ErrorAdmin.vue?vue&type=script&lang=js"
export * from "./ErrorAdmin.vue?vue&type=script&lang=js"
import style0 from "./ErrorAdmin.vue?vue&type=style&index=0&id=7ad5b11e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports